import { Nullable } from "../base-types";

export class ValidationFailure {
    readonly source: Nullable<string>;
    readonly message: Nullable<string>;

    constructor(message?: Nullable<string>, source?: Nullable<string>) {
        this.message = message ?? null;
        this.source = source ?? null;
    }

    toString(): string {
        return `${this.source ?? "No source was specified"}: ${this.message ?? "No message was specified"}`;
    }
}
